import { getHashSearchParam } from './common';
console.log(navigator.userAgent, appUserAgentInfo);
// app版本号
window.appVersion = navigator.userAgent.toLowerCase().split(' ')[0].split('juno/')[1]
    ? navigator.userAgent.toLowerCase().split(' ')[0].split('juno/')[1]
    : '';

// 是否在juno app内打开
window.isJunoApp =
    location.hostname == 'localhost'
        ? true
        : window.navigator.userAgent.toLowerCase().match(/juno/i) == 'juno';

// Apikey
var commonApiKey = getHashSearchParam('Apikey') || localStorage.getItem('Apikey');
if (commonApiKey) {
    localStorage.setItem('Apikey', commonApiKey);
    window.Apikey = commonApiKey;
}

// 获取app传递的用户代理信息
// const a = 'Juno|1.0.2|3da10ae50e6c4699|Asia/Shanghai|Redmi|22041211AC|mobile|zh-CN|首页 (Redmi android SP1A.210812.016; Scale|2.625)'
try {
    var appUserAgentInfoArray = navigator.userAgent.split(' (')[0].split('|');

    let commonAgent;
    if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
        //判断iPhone|iPad|iPod|iOS
        commonAgent = 'ios';
    } else if (/(Android)/i.test(navigator.userAgent)) {
        //判断Android
        commonAgent = 'android';
    } else {
        //pc
        commonAgent = 'pc';
    }

    var appUserAgentInfo = {
        juno_appid: 'juno',
        juno_agent: commonAgent || '',
        juno_name: appUserAgentInfoArray[0] || '',
        juno_vs: appUserAgentInfoArray[1] || '',
        juno_deviceid: appUserAgentInfoArray[2] || '',
        juno_region: appUserAgentInfoArray[3] || '',
        juno_brand: appUserAgentInfoArray[4] || '', //手机品牌
        juno_model: appUserAgentInfoArray[5] || '', //手机型号
        juno_network: appUserAgentInfoArray[6] || '', //网络类型
        juno_lang: getHashSearchParam('lang') || appUserAgentInfoArray[7] || 'en-US', //语言
        jun_source: navigator.userAgent.split('&')[1]?navigator.userAgent.split('&')[1]:'',
    };
    window.appUserAgentInfo = appUserAgentInfo;
} catch (error) {
    console.error('获取app-userAgent信息失败-', error);
}
